import { Component, input, output, AfterViewChecked, viewChild, ElementRef } from '@angular/core';
import { ChatMessage } from '../../interfaces';
import { ChatMessageItem } from '../chat-message-item/chat-message-item';
import { BotTypingLoader } from '@/shared/components/bot-typing-loader/bot-typing-loader';

@Component({
  selector: 'bevvi-chat-body',
  imports: [ChatMessageItem, BotTypingLoader],
  templateUrl: './chat-body.html',
  styleUrl: './chat-body.css',
})
export class ChatBody implements AfterViewChecked {
  public readonly messages = input.required<ChatMessage[]>();
  public readonly loading = input(false);

  public readonly userReply = output<{ label: string; sourceMessageId: string }>();
  protected readonly scrollContainer = viewChild<ElementRef<HTMLDivElement>>('scrollContainer');

  public ngAfterViewChecked(): void {
    const container = this.scrollContainer()?.nativeElement;

    if (!container) return;

    container.scrollTop = container.scrollHeight;
  }
}
